export default __webpack_public_path__ + "static/media/greySales.091102d4.svg";